module.exports = __webpack_public_path__ + "static/media/MC T5.f525a7a0.jpg";